interface StructureOfferCardSkeletonProps {
  showGetQuoteLink?: boolean
}

export function StructureOfferCardSkeleton({
  showGetQuoteLink = true,
}: StructureOfferCardSkeletonProps) {
  return (
    <div className="flex h-full flex-col rounded-lg border border-[#DEDEDE] bg-white px-5 py-6 shadow-[0px_3px_8px_0px_rgba(78,44,110,0.07)]">
      <div className="mb-10 text-left">
        <div className="mb-1 h-7 w-16 animate-pulse rounded bg-[#E5E5E5]" />
        <div className="h-4 w-20 animate-pulse rounded bg-[#E5E5E5]" />
      </div>
      <div className="mb-10 flex items-baseline gap-1 text-left">
        <div className="h-5 w-14 animate-pulse rounded bg-[#E5E5E5]" />
        <div className="h-4 w-12 animate-pulse rounded bg-[#E5E5E5]" />
      </div>
      <div className="flex-1" />
      <div className="mb-6 flex flex-col items-center">
        <div className="h-10 w-full max-w-[200px] animate-pulse rounded-md bg-[#E5E5E5]" />
      </div>
      {showGetQuoteLink && (
        <div className="flex justify-center">
          <div className="h-4 w-28 animate-pulse rounded bg-[#E5E5E5]" />
        </div>
      )}
    </div>
  )
}
